module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M0 32v-6.857L17.143 8 24 14.857 6.857 32zM20.571 4.571l3.568-3.568a3.428 3.428 0 0 1 4.848 0l2.009 2.009a3.428 3.428 0 0 1 0 4.848l-3.568 3.568-6.857-6.857z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/pencil-3.js
// module id = 1341
// module chunks = 14